import { useUser } from "./useUser";

// type Action = "view" | "create" | "edit" | "delete";
type Resource = "task" | "project" | "user" | "board";
// edit, completed, pending, in_progress, delete, hold
const action_prevent = [
    "delete_task",
    "create_project",
    "edit_project",
    "completed_project",
    "pending_project",
    "hold_project",
    "delete_project",
]

export function usePermission() {
    const { profile } = useUser();

    const isAdmin = profile?.isAdmin === 1;

    const can = (action: string, resource: Resource) => {
        // if admin
        if (isAdmin) return true;

        // if member
        if (action_prevent.includes(`${action}_${resource}`)) return false;

        return true;
    };

    return { can, isAdmin };
}
